import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { ITableHeader } from '~/config/table/headers';


export default /*#__PURE__*/_defineComponent({
  __name: 'Table',
  props: {
    headers: { default: () => [] },
    rows: { default: () => [] },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["clickRow"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'clickRow', item: Record<string, any>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { headers: ITableHeader[], rows: Array<{
      rowClass?: Record<string, boolean>;
      tdClass?: Record<string, boolean>;
      cellClass?: Record<string, boolean>;
      item: Record<string, any>;
    }>, isLoading: boolean };



const {} = useContext();

return { __sfc: true,emit, props }
}

})